import React, { createContext, useState, useContext, useEffect } from 'react';
import { translations } from './translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Obtener idioma del localStorage o usar español por defecto
    return localStorage.getItem('language') || 'es';
  });

  useEffect(() => {
    // Guardar el idioma seleccionado en localStorage
    localStorage.setItem('language', language);
  }, [language]);

  const t = (path) => {
    // Acceder a las traducciones usando notación de punto
    // Ej: t('header.aboutBtn') -> translations[language].header.aboutBtn
    return path.split('.').reduce((obj, key) => obj?.[key], translations[language]) || path;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage debe ser usado dentro de LanguageProvider');
  }
  return context;
};
